/*
 * dashboard (page)
 */
import { Container, PageHeader, Page } from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import {
	Bot,
	Clipboard,
	// Calendar,
	HeartPlus,
	MessagesSquare,
	PocketKnife,
	ScrollText,
	User,
	Users,
} from "lucide-react"
import { DashboardCard } from "../components/dashboard-card"
import { authPageLoader } from "../utils/auth.utils"

export const Route = createFileRoute("/dashboard")({
	component: DashboardPage,
	loader: authPageLoader,
})

function DashboardPage() {
	return (
		<Page>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				<PageHeader title={"EMR Dashboard"} />

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					<DashboardCard
						title="User Details"
						description="Share optional background details here. This helps our AI understand your unique context for more relevant insights and tailored support across all features."
						to="/user-details"
						icon={<User className="w-8 h-8" />}
						gradient="from-slate-500 to-slate-300"
					/>
				</div>
			</Container>
		</Page>
	)
}
